export default class CustomValidation {

  constructor(validator){
    validator.validators.presentPerUserType = this.initPresentPerUserType;
    validator.validators.presentPerCountry = this.initPresentPerCountry;
    validator.validators.presentPerIrelandDoctor = this.initPresentPerIrelandDoctor;
  }

  initPresentPerUserType = (value, options, key, attributes) => {
    let userType = attributes.user_type;
    if(options.user_types.includes(userType) && (value === null || value === '')){
      return options.message;
    }
  };

  initPresentPerCountry = (value, options, key, attributes) => {
    let country = attributes.country;
    if(options.countries.includes(country) && (value === null || value === '')) {
      return options.message;
    }
  };

  initPresentPerIrelandDoctor = (value, options, key, attributes) => {
    let country = attributes.country;
    let userType = attributes.user_type;
    if(options.countries.includes(country) && options.user_types.includes(userType) && (value === null || value === '')) {
      return options.message;
    }
  };

}



// WEBPACK FOOTER //
// ./src/constants/customValidations.js